import { ComputedRef, InjectionKey } from "vue";

export const dsSegmentedInjectedKey = Symbol() as InjectionKey<ComputedRef<string>>;
